module.exports = __webpack_public_path__ + "static/img/culture_four.28c1b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/corporateCulture/culture_four.png
// module id = vLww
// module chunks = 1